import { render, staticRenderFns } from "./newInstitution.vue?vue&type=template&id=b65a4888&scoped=true"
import script from "./newInstitution.vue?vue&type=script&lang=js"
export * from "./newInstitution.vue?vue&type=script&lang=js"
import style0 from "./newInstitution.vue?vue&type=style&index=0&id=b65a4888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65a4888",
  null
  
)

export default component.exports